import { useClientPortalAPI } from "@certn/api";
import { useContext } from "react";

import { OrderContext } from "../OrderContext";

export function useOrderBillingProfile() {
  const { order } = useContext(OrderContext);

  return useClientPortalAPI(
    order?.group ? `/api/internal/client-portal/order/billing-profile/` : null,
    { group: order.group }
  );
}
